import { forwardRef } from "react"
import { LoadingIcon } from "../../Icon"
import type { ButtonComponentProps, ButtonLinkComponentProps } from "./type"

const InnerButton = ({
  children,
  loading,
}: {
  children:
    | ButtonComponentProps["children"]
    | ButtonLinkComponentProps["children"]
  loading: ButtonComponentProps["loading"] | ButtonLinkComponentProps["loading"]
}) => (
  <>
    {loading && <LoadingIcon className="cobalt-button__loading-icon" />}
    {children}
  </>
)

export const ButtonBase = forwardRef<HTMLButtonElement, ButtonComponentProps>(
  (props: ButtonComponentProps, ref) => {
    const { disabled, loading, children, ...restProps } = props
    return (
      <button
        ref={ref}
        aria-disabled={disabled || loading}
        aria-busy={loading}
        disabled={disabled || loading}
        {...restProps}
      >
        <InnerButton loading={loading}>{children}</InnerButton>
      </button>
    )
  },
)
ButtonBase.displayName = "ButtonBase"

export const ButtonLinkBase = forwardRef<
  HTMLAnchorElement,
  ButtonLinkComponentProps
>((props: ButtonLinkComponentProps, ref) => {
  const { disabled, target, rel, loading, children, ...restProps } = props
  return (
    <a
      ref={ref}
      aria-disabled={disabled || loading}
      aria-busy={loading}
      data-disabled={disabled || loading}
      target={target}
      rel={target === "_blank" && !rel ? "noopener noreferrer" : rel}
      {...restProps}
    >
      <InnerButton loading={loading}>{children}</InnerButton>
    </a>
  )
})
ButtonLinkBase.displayName = "ButtonLinkBase"
